import _ from "lodash";
import {
  TableCellType,
  TableHeader,
} from "../../../components/custom-table/table";
import { NYCBSMedicalPA } from "../../../data-model/nycbsMedicalPa";
import { EligibilityCheckTableData } from "../../../data-model/tablesData";
import { ColoredText } from "../../../enums/coloredText";
import { EligibilityCheckTableColumnKeys } from "../../../enums/tableColumnKeys";
import { capitalizeWordsSeperatedByUnderScore } from "../../../utils/stringModifications";

export const EligibilityTableHeader: TableHeader[] = [
  {
    label: "ID",
    key: EligibilityCheckTableColumnKeys.ID,
    order: 1,
    width: 20,
    sortable: true,
    type: TableCellType.COPY_DATA,
  },
  {
    label: "Created At",
    key: EligibilityCheckTableColumnKeys.CREATED_AT,
    order: 2,
    width: 20,
    sortable: true,
    type: TableCellType.DATE,
  },
  {
    label: "Report Generated At",
    key: EligibilityCheckTableColumnKeys.REPORT_DATE,
    order: 3,
    width: 20,
    sortable: true,
    type: TableCellType.DATE,
  },
  {
    label: "Total Orders",
    key: EligibilityCheckTableColumnKeys.TOTAL_ORDERS,
    order: 4,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Status",
    key: EligibilityCheckTableColumnKeys.STATUS,
    order: 5,
    width: 10,
    sortable: true,
    type: TableCellType.COLORED_TEXT,
  },
  {
    label: "",
    key: EligibilityCheckTableColumnKeys.DOWNLOAD_FILE,
    order: 6,
    width: 10,
    type: TableCellType.CLICKABLE_TEXT_WITH_DISABLED_STATUS,
  },
  {
    label: "",
    key: EligibilityCheckTableColumnKeys.VIEW_DETAILS,
    order: 7,
    width: 10,
    type: TableCellType.BUTTON_LINK,
  },
];

export const EligibilityTableData = [
  {
    id: 1,
    createdAt: "2021-01-01",
    reportDate: "2021-01-01",
    totalOrders: 1,
    status: {
      text: _.capitalize("success"),
      color: ColoredText.True,
    },
    downloadFile: {
      data: "Download",
      status: "disabled",
    },
    viewDetails: "View Details",
  },
  {
    id: 2,
    createdAt: "2021-01-01",
    reportDate: "2021-01-01",
    totalOrders: 1,
    status: {
      text: _.capitalize("Inprogress"),
      color: ColoredText.Inprogress,
    },
    downloadFile: {
      data: "Download",
      status: "",
    },
    viewDetails: "https://www.google.com",
  },
  {
    id: 3,
    createdAt: "2021-01-01",
    reportDate: "2021-01-01",
    totalOrders: 1,
    status: {
      text: _.capitalize("success"),
      color: ColoredText.True,
    },
    downloadFile: "https://www.google.com",
    viewDetails: "https://www.google.com",
  },
  {
    id: 4,
    createdAt: "2021-01-01",
    reportDate: "2021-01-01",
    totalOrders: 1,
    status: {
      text: _.capitalize("success"),
      color: ColoredText.True,
    },
    downloadFile: "https://www.google.com",
    viewDetails: "https://www.google.com",
  },
];

export const generateEligibilityTableData = (
  data: NYCBSMedicalPA[],
): EligibilityCheckTableData[] => {
  return data.map((item) => {
    const id = item?.job_id ?? "";
    const createdAt = item?.created_at ?? "";
    const reportDate = item?.report_generated_at ?? "";
    const totalOrders = item?.total_orders ?? 0;
    const status = {
      text: capitalizeWordsSeperatedByUnderScore(item?.status ?? ""),
      color:
        item?.status === "completed"
          ? ColoredText.True
          : ColoredText.Inprogress,
    };
    const downloadFile = {
      data: "Download",
      status: item?.status === "completed" ? "" : "disabled",
    };
    const viewDetails =
      item?.status === "completed" ? "View Details" : "View Progress";

    return {
      id,
      createdAt,
      reportDate,
      totalOrders: totalOrders.toString(),
      status,
      downloadFile,
      viewDetails,
    };
  });
};

export const updateDownloadStatusOfOrderWithId = (
  data: EligibilityCheckTableData[],
  id: string,
  status: boolean,
) => {
  return data.map((item) => {
    if (item.id === id) {
      item.downloadFile.data = status ? "Download" : "Downloading...";
    }
    return item;
  });
};
